import { Theme } from '@mui/material';

export function MUICreateAnimationTiming(theme:Theme, name:string){
    return theme.transitions.create(name, {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  }